// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3PZOU","content":"styles_content__5upHp","selectAll":"styles_selectAll__AnWhv"};